import { type MetaFunction } from '@remix-run/node'
import { LegalPageLayout } from '#app/components/legal/LegalPageLayout.tsx'

export const meta: MetaFunction = () => [
	{ title: 'Política de privacidad | Asociación Síndrome PCDH19' },
]

export default function PoliticaPrivacidadRoute() {
	return (
		<LegalPageLayout
			title="Política de privacidad"
			intro="ASOCIACIÓN SINDROME PCDH19 es el RESPONSABLE del tratamiento de los datos personales del USUARIO y los trata conforme al RGPD y la LOPDGDD."
		>
			<h2>1. INFORMACIÓN AL USUARIO</h2>
			<h3>¿Quién es el responsable del tratamiento de tus datos personales?</h3>
			<p>
				ASOCIACIÓN SINDROME PCDH19 es el RESPONSABLE del tratamiento de los datos
				personales del USUARIO y le informa de que estos datos serán tratados de
				conformidad con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril
				(RGPD), y la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD).
			</p>

			<h3>¿Para qué tratamos tus datos personales y por qué lo hacemos?</h3>
			<p>
				Según el formulario donde hayamos obtenido sus datos personales, los
				trataremos de manera confidencial para alcanzar los fines que correspondan.
			</p>
			<p>
				En el documento legal aportado se hace constar literalmente: <strong>FALTAN DATOS</strong>.
				 Para completar automáticamente este apartado, es necesario añadir previamente
				los formularios en la ficha del sitio web y política de privacidad.
			</p>

			<h3>¿Durante cuánto tiempo guardaremos tus datos personales?</h3>
			<p>
				Se conservarán durante no más tiempo del necesario para mantener el fin del
				tratamiento o existan prescripciones legales que dictaminen su custodia y,
				cuando ya no sea necesario para ello, se suprimirán con medidas de seguridad
				adecuadas para garantizar la anonimización de los datos o la destrucción
				total de los mismos.
			</p>

			<h3>¿A quién facilitamos tus datos personales?</h3>
			<p>
				No está prevista ninguna comunicación de datos personales a terceros salvo,
				si fuese necesario para el desarrollo y ejecución de las finalidades del
				tratamiento, a nuestros proveedores de servicios relacionados con
				comunicaciones, con los cuales el RESPONSABLE tiene suscritos los
				contratos de confidencialidad y de encargado de tratamiento exigidos por la
				normativa vigente de privacidad.
			</p>

			<h3>¿Cuáles son tus derechos?</h3>
			<p>Los derechos que asisten al USUARIO son:</p>
			<ul>
				<li>Derecho a retirar el consentimiento en cualquier momento.</li>
				<li>
					Derecho de acceso, rectificación, portabilidad y supresión de sus datos,
					y de limitación u oposición a su tratamiento.
				</li>
				<li>
					Derecho a presentar una reclamación ante la autoridad de control
					(www.aepd.es) si considera que el tratamiento no se ajusta a la normativa
					vigente.
				</li>
			</ul>

			<p><strong>Datos de contacto para ejercer sus derechos:</strong></p>
			<p>
				ASOCIACIÓN SINDROME PCDH19. Calle Violín, 27 - 29620 Torremolinos
				(Málaga). E-mail: sociospcdh19@gmail.com.
			</p>
			<p>
				Datos de contacto del delegado de protección de datos: Consulting
				Normativo, S.L, C/ Ferraz 28, 2º izquierda, Madrid -
				dpd@consultingnormativo.es.
			</p>

			<h2>
				2. CARÁCTER OBLIGATORIO O FACULTATIVO DE LA INFORMACIÓN FACILITADA POR EL
				USUARIO
			</h2>
			<p>
				Los USUARIOS, mediante la marcación de las casillas correspondientes y la
				entrada de datos en los campos marcados con un asterisco (*) en el
				formulario de contacto o presentados en formularios de descarga, aceptan
				expresamente y de forma libre e inequívoca que sus datos son necesarios
				para atender su petición por parte del prestador, siendo voluntaria la
				inclusión de datos en los campos restantes.
			</p>
			<p>
				El USUARIO garantiza que los datos personales facilitados al RESPONSABLE
				son veraces y se hace responsable de comunicar cualquier modificación de
				los mismos.
			</p>
			<p>
				El RESPONSABLE informa de que todos los datos solicitados a través del sitio
				web son obligatorios, ya que son necesarios para la prestación de un
				servicio óptimo al USUARIO. En caso de que no se faciliten todos los datos,
				no se garantiza que la información y servicios facilitados sean
				completamente ajustados a sus necesidades.
			</p>

			<h2>3. MEDIDAS DE SEGURIDAD</h2>
			<p>
				De conformidad con lo dispuesto en las normativas vigentes en protección de
				datos personales, el RESPONSABLE está cumpliendo con todas las
				disposiciones de las normativas RGPD y LOPDGDD para el tratamiento de los
				datos personales de su responsabilidad y, manifiestamente, con los
				principios descritos en el artículo 5 del RGPD.
			</p>
			<p>
				El RESPONSABLE garantiza que ha implementado políticas técnicas y
				organizativas apropiadas para aplicar las medidas de seguridad que
				establecen el RGPD y la LOPDGDD con el fin de proteger los derechos y
				libertades de los USUARIOS.
			</p>
			<p>
				Para más información sobre las garantías de privacidad, puedes dirigirte al
				RESPONSABLE a través de ASOCIACIÓN SINDROME PCDH19. Calle Violín, 27 -
				29620 Torremolinos (Málaga). E-mail: sociospcdh19@gmail.com.
			</p>
			<p>
				Datos de contacto del delegado de protección de datos: Consulting
				Normativo, S.L, C/ Ferraz 28, 2º izquierda, Madrid -
				dpd@consultingnormativo.es.
			</p>
		</LegalPageLayout>
	)
}
